import { render, staticRenderFns } from "./TasklistTabsSection.vue?vue&type=template&id=403106ee&scoped=true"
import script from "./TasklistTabsSection.vue?vue&type=script&lang=js"
export * from "./TasklistTabsSection.vue?vue&type=script&lang=js"
import style0 from "./TasklistTabsSection.vue?vue&type=style&index=0&id=403106ee&prod&lang=scss"
import style1 from "./TasklistTabsSection.vue?vue&type=style&index=1&id=403106ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403106ee",
  null
  
)

export default component.exports